import * as reduxForm from 'redux-form';

const SET_CONTACT = 'gratis-app/SET_CONTACT';

export default function reducer( state = '', action ) {
    switch ( action.type ) {
        case SET_CONTACT:
            return action.contact;
        default:
            return state;
    }
}

export function setContact( emailOrId, props ) {

    return ( dispatch, getState ) => {
        const st = getState();
        fetch( `${st.options.ws.base}/api/v1/${st.office.code}/contacts/${emailOrId}/accounts.json` )
            .then( function ( response ) {
                return response.json();
            } )
            .then( function ( json ) {
                var contacts = json.contacts;
                if( contacts && contacts.length == 1) {
                    console.log(props);
                    var contact = contacts[ 0 ];
                    // XXX: hardcoding form name...again!
                    //json.code = office;
                    //dispatch( reduxForm.registerField( 'gratisForm', 'office', 'Field' ) );
                    dispatch( reduxForm.change( 'gratisForm', 'email', contact.email ) );
                    dispatch( {
                        type   : SET_CONTACT,
                        contact: contact
                    } );
                    dispatch( reduxForm.change( 'gratisForm', 'department', contact.accountid ) );
                    dispatch( reduxForm.change( 'gratisForm', 'institution', contact.account.parentid ) );
                }
            } )
            .catch( function ( ex ) {
                console.log( ex );
            } );
    }
}



// WEBPACK FOOTER //
// ./src/form/redux/modules/contact.js